import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestWebhooks} from "../../../redux/Actions/webhooks.actions";
import {
  getWebhooksList,
  getWebhooksTotalCount,
  getWebhooksPaginationUrls,
} from "../../../redux/Selectors/webhooks.selector";

export const useFetchWebhooks = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestWebhooks());
  };

  const refetch = () => {
    dispatch(requestWebhooks(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useWebhooksTableData = () => {
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchWebhooks();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const webhookList = useSelector(getWebhooksList);
  const webhookTotalCount = useSelector(getWebhooksTotalCount);
  const webhookUrls = useSelector(getWebhooksPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (webhookList.length === 1) {
      // If the last webhook on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? webhookUrls?.nextUrl : webhookUrls?.prevUrl;
    dispatch(requestWebhooks(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return {fetchAfterDelete, paginationConfig, webhookList, webhookTotalCount};
};
